<template>
  <div>
    <CRow>
      <CCol
        md="12"
        sm="12"
        lg="12"
        xl="12"
        style="padding-left: 0px;padding-right: 0px;"
      >
        <CCard class="notification">
          <CCardHeader>
            <strong>Notifications</strong>
          </CCardHeader>

          <CCardBody v-if="notifysObj.length > 0">
            <CListGroup v-for="(item, index) in notifysObj" :key="index">
              <!--{{item.notify.date}}
              <hr>-->

              <CListGroupItem
                v-if="item.notify.notifytype != undefined"
                href="#"
                @click="onRead(item.notify._id)"
                class="flex-column align-items-start hover unread-text"
              >
                <img
                  v-if="item.read"
                  src="@/assets/icons/Bell green.svg"
                  class="notiIcon"
                />
                <img
                  v-else
                  src="@/assets/icons/Bell Red.svg"
                  class="notiIcon"
                />
                <header>
                  <h5 v-if="item.notify.notifytype == 0" class="mb-1 header">
                    COURSE
                  </h5>
                  <h5 v-if="item.notify.notifytype == 1" class="mb-1 header">
                    PAYMENT
                  </h5>
                  <h5 v-if="item.notify.notifytype == 2" class="mb-2 header">
                    STATUS
                  </h5>
                </header>
                <div>
                  <p class="message">{{ item.notify.messages[0].val }}</p>
                </div>
                <footer class="w-100 justify-content-between footer row">
                  <p class="time col">{{ onDateFormat(item.notify.date) }}</p>

                  <p v-if="!item.read" class="read mr-3 col text-right">
                    Mark as read
                  </p>
                </footer>
              </CListGroupItem>
            </CListGroup>
          </CCardBody>
          <CCardBody v-else>
            <h3>No Notification</h3>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {},
  data() {
    return {
      notifysObj: [],
    };
  },
  created() {},
  mounted() {
    if (this.$store.getters["auth/userStatus"]) {
      this.$store.dispatch("profile/getUserNoticeData");
    }
  },
  computed: {
    ...mapGetters({
      getNotice: "profile/getUserNotice",
      getMarking: "updateProfile/getMarkging",
    }),
  },
  watch: {
    getNotice: function(val) {
      this.notifysObj = val;
    },
    getMarking: function(val) {
      if (val == false) {
        if (this.$store.getters["auth/userStatus"]) {
          this.$store.dispatch("profile/getUserNoticeData");
        }
      }
    },
  },
  methods: {
    onRead(id) {
      const body = {
        notifyId: id,
      };
      this.$store.dispatch("updateProfile/onMarkNotice", body);
    },

    onDateFormat(date) {
      return new Date(date)
        .toISOString()
        .replace(/T/, " ")
        .replace(/\..+/, "");
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");
.notification {
  border-bottom-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  -webkit-box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  border-color: transparent;
}
.card-header {
  background-color: white;
  border-top-right-radius: 0.75rem;
  border-top-left-radius: 0rem;
}
.card-header strong {
  font-size: 24px;
  float: left;
}
.card-header p {
  font-size: 16px;
  float: right;
  font-family: Roboto;
  font-weight: bold;
  margin-top: 0.5em;
}
.card-body {
  min-height: 220px;
}
.unread {
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  overflow: scroll;
  height: 572px;
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  color: black;
}
.list-group-item {
  border-color: transparent;
}
.list-group-item:hover {
  background-color: #0080ff;
  -webkit-box-shadow: 5px 5px 5px rgba(148, 146, 148, 1);
  -moz-box-shadow: 5px 5px 5px rgba(148, 146, 148, 1);
  box-shadow: 5px 5px 5px rgba(148, 146, 148, 1);
}
.unread-text {
  color: black !important ;
}
.unread-text:hover {
  color: white !important ;
}
.list-group-item:first-child {
  border-top-left-radius: 0rem;
  border-top-right-radius: 0rem;
}
.notiIcon {
  width: 36px;
  height: 36px;
  float: left;
  margin-top: 1.8em;
}
.header {
  margin-left: 3em;
  font-family: Roboto;
  font-weight: 600;
  font-size: 20px;
}
.message {
  margin-left: 3.8em;
  margin-right: 5em;
  font-family: Roboto;
  font-weight: 300;
  font-size: 16px;
}
.time {
  margin-left: 4.4em;
  float: left;
  font-family: Roboto;
  font-weight: bold;
  font-size: 14px;
}
.read {
  float: right;
  font-family: Roboto;
  font-weight: bold;
  font-size: 16px;
}
.footer {
  margin-top: -0.5em;
}
.ps__rail-y {
  top: 0px;
  height: 302px;
  right: 0px;
}
.readed {
  border-bottom-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
  border-top-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  -webkit-box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  border-color: #cccccc;
  height: 572px;
  border-radius: 20px;
  opacity: 1;
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
}
.readedbg {
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  overflow: scroll;
  height: 572px;
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  background-color: gray;
}
.header-unread {
  border-top-left-radius: 0.75rem;
  background-color: gray;
  color: white;
}
.list-group-item-read {
  background-color: gray;
}
.read-text {
  color: white !important ;
}
.read-text:hover {
  color: black !important ;
}
.list-group-item-read:hover {
  background-color: white;
  -webkit-box-shadow: 5px 5px 5px rgba(87, 87, 87, 1);
  -moz-box-shadow: 5px 5px 5px rgba(87, 87, 87, 1);
  box-shadow: 5px 5px 5px rgba(87, 87, 87, 1);
}
</style>
